import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

export function InviteForm({ teamId, onDone }) {
  const [ident, setIdent] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post(`/teams/${teamId}/members`, { identifier: ident, name }); toast.success("Member added"); onDone(); }
    catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="space-y-4">
      <div>
        <div className="text-xs text-black/55 mb-2 uppercase tracking-widest">Email or mobile</div>
        <input data-testid="invite-identifier" value={ident} onChange={(e) => setIdent(e.target.value)} required className="w-full px-3 py-2.5 border border-black/15 rounded-md outline-none focus:border-black" placeholder="person@example.com or +91…"/>
      </div>
      <div>
        <div className="text-xs text-black/55 mb-2 uppercase tracking-widest">Name (optional)</div>
        <input data-testid="invite-name" value={name} onChange={(e) => setName(e.target.value)} className="w-full px-3 py-2.5 border border-black/15 rounded-md outline-none focus:border-black" placeholder="Display name"/>
      </div>
      <button data-testid="invite-submit" disabled={busy} className="w-full bg-black text-white py-2.5 rounded-md disabled:opacity-50">{busy ? "Adding…" : "Add member"}</button>
    </form>
  );
}

export function ResetForm({ teamId, onDone }) {
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post(`/teams/${teamId}/reset-password`, { new_password: pw }); toast.success("Password updated"); onDone(); }
    catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="space-y-4">
      <div>
        <div className="text-xs text-black/55 mb-2 uppercase tracking-widest">New team password</div>
        <input data-testid="reset-input" type="text" minLength={4} required value={pw} onChange={(e) => setPw(e.target.value)} className="w-full px-3 py-2.5 border border-black/15 rounded-md outline-none focus:border-black" placeholder="Min 4 characters"/>
      </div>
      <button data-testid="reset-submit" disabled={busy} className="w-full bg-black text-white py-2.5 rounded-md disabled:opacity-50">{busy ? "Saving…" : "Reset password"}</button>
    </form>
  );
}
